import { Pipe, PipeTransform } from '@angular/core';

const ESPACO = ' ';
const primeiroMaiusculo = (str) => str.charAt(0).toUpperCase() + str.slice(1);
const forcePrimeiroMaiusculo = (str) => primeiroMaiusculo(str.toLowerCase());
const verificaPossibilidade = (lista, palavra) => (
  lista.filter(item => item.toLowerCase() === palavra.toLowerCase()).length > 0
);

class ConfiguracoesPadrao {
  exceto = [];
  forcar = [];
  forcarCaixaBaixa = [];
  forcarCaixaAlta = [];
  todasPalavras = false;
  constructor(params) {
    Object.assign(this, params);
  }
}

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {

  transform(value: any, configuracoes = {}) {
    if (!value || typeof value !== 'string') {
      return '';
    }
    const { todasPalavras, exceto, forcar, forcarCaixaBaixa, forcarCaixaAlta } = new ConfiguracoesPadrao(configuracoes);
    const frase = value.split(ESPACO).map((palavra) => {

      if (verificaPossibilidade(forcarCaixaBaixa, palavra)) {
        return palavra.toLowerCase();
      }

      if (verificaPossibilidade(forcarCaixaAlta, palavra)) {
        return palavra.toUpperCase();
      }

      if (verificaPossibilidade(forcar, palavra)) {
        return forcePrimeiroMaiusculo(palavra);
      }

      if (verificaPossibilidade(exceto, palavra)) {
        return palavra;
      }

      return todasPalavras ? forcePrimeiroMaiusculo(palavra) : palavra.toLowerCase();

    }).join(ESPACO);

    return primeiroMaiusculo(frase);
  }
}
